import { Box, Fade, Paper, Typography } from '@mui/material';
import DocumentsSection from '@acorn-portal/shared/src/components/renewal/documents-section';
import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import FlagLanderBanner from '@acorn-portal/shared/src/components/banner/FlagLanderBanner';
import { format } from 'date-fns';
import { DISPLAY_DATE_TIME } from '@acorn-portal/shared/src/utils/constants';
import { FullPolicy } from '@acorn-portal/shared/src/services/api';
import { clearFullPolicyDetails } from '@acorn-portal/shared/src/store/fullPolicy.slice';

const PaymentSuccess = () => {
	const dispatch = useAppDispatch();
	const [policy] = useState<FullPolicy>(useAppSelector((x) => x.fullPolicy));
	const contactPreferences = useAppSelector((redux) => redux.contactPreferences);
	const renewal = useAppSelector((x) => x.renewal);
	const navigate = useNavigate();

	useEffect(() => {
		if (policy.policyNumber) {
			dispatch(clearFullPolicyDetails());
		} else navigate(ROUTE_PATHS.home);
	}, []);

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<FlagLanderBanner
				text={
					<Box
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								fontSize: '1.4rem',
								width: '80%',
							},
							[theme.breakpoints.down('sm')]: {
								fontSize: '1.1rem',
								width: '65%',
							},
						})}
					>
						Thank you for your payment!
					</Box>
				}
			/>
			<Fade in>
				<Box
					sx={{
						p: { xs: 2, md: 4 },
						margin: 2,
						textAlign: 'center',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							p: 2,
							borderRadius: 2,
							backgroundColor: green[50],
							my: 2,
						}}
					>
						<CheckCircleIcon sx={{ color: green[500], marginRight: 1, fontSize: '32px' }} />
						<Typography
							sx={{
								fontWeight: 400,
								fontSize: '18px',
								color: green[500],
							}}
						>
							Your renewal has been successful with the effective date of{' '}
							{renewal.isFutureDatedRenewal && renewal.futureRenewalStartDate
								? format(new Date(renewal.futureRenewalStartDate), DISPLAY_DATE_TIME)
								: format(new Date(renewal.renewalStartDate), DISPLAY_DATE_TIME)}
						</Typography>
					</Box>
					<Typography fontSize={16} paddingBottom={4} color='secondary'>
						Please find your policy documents below
					</Typography>
					<Typography sx={{ maxWidth: { md: '50%' } }}>
						Your policy reference number:{' '}
						<strong>{renewal.isFutureDatedRenewal ? renewal.futureRenewalNewPolicyNo : policy.policyNumber}</strong>
						<br /> Details of how to access the documents have been emailed to you and are available below
					</Typography>
					{contactPreferences.printToPost && (
						<Typography sx={{ margin: 'auto', textAlign: 'center', p: 2 }}>
							We&apos;ve also sent your updated documents in the post, they will arrive in 3-5 working days.
						</Typography>
					)}
					<DocumentsSection policy={policy} />
				</Box>
			</Fade>
		</Paper>
	);
};

export default PaymentSuccess;
